<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">供货计划</span>
                            <RadioGroup
                                v-model="year"
                                @on-change="onYearChange"
                            >
                                <Radio
                                    v-for="(item, index) in yearList"
                                    :key="index"
                                    :label="item"
                                >
                                    <span>{{ item }}年</span>
                                </Radio>
                            </RadioGroup>
                            <Checkbox
                                v-model="existsOnly"
                                @on-change="onShowExistsOnly"
                                style="width: 80px"
                                >只看有供货
                            </Checkbox>
                            <Checkbox
                                v-model="receivedOrder"
                                @on-change="onShowReceivedOrder"
                                style="width: 80px"
                                >显示已接单
                            </Checkbox>
                            <Select
                                v-if="readOnly"
                                v-model="selectedSeedFarmUuid"
                                style="width: 200px; margin-left: 5px"
                                size="small"
                                placeholder="选择苗场"
                                @on-change="onSeedFarmChange"
                                filterable
                            >
                                <Option
                                    v-for="item in seedFarmList"
                                    :value="item.seedFarmUuid"
                                    :key="item.seedFarmUuid"
                                >
                                    {{
                                        item.seedFarmCode +
                                        " " +
                                        item.seedFarmName
                                    }}
                                </Option>
                            </Select>
                            <Input
                                v-model="keyWord"
                                search
                                size="small"
                                enter-button="查询"
                                style="width: 200px; margin-left: 5px"
                                placeholder="小类名称/产品编号/产品名称"
                                @on-search="onSearch"
                            />
                            <Button
                                type="warning"
                                v-if="this.isMainAccount == 1"
                                size="small"
                                icon="md-calendar"
                                shape="circle"
                                style="margin-left: 5px"
                                @click="showModal"
                                >周期选择</Button
                            >
                            <Button
                                type="error"
                                v-if="this.isMainAccount == 1"
                                size="small"
                                icon="md-link"
                                shape="circle"
                                style="margin-left: 5px"
                                @click="showBindindModal"
                                >周数绑定</Button
                            >
                            <Button
                                v-if="!readOnly && isMainAccount == 1"
                                type="success"
                                size="small"
                                icon="ios-checkmark"
                                shape="circle"
                                style="margin-left: 5px"
                                @click="onSave"
                                >保存</Button
                            >
                            <Button
                                type="error"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                ghost
                                @click="onClickImport()"
                                v-if="this.isMainAccount == 1"
                                >导入</Button
                            >
                            <Button
                                type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                @click="onExport()"
                                >导出</Button
                            >
                            <Button
                                type="info"
                                size="small"
                                class="success"
                                style="width: 100px"
                                shape="circle"
                                icon="ios-send"
                                @click="onExportByDateRangeShow()"
                                >按周期导出</Button
                            >
                        </div>
                        <div class="right-bar"></div>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        ref="mainTable"
                        :columns="mainTable.tableColumns"
                        :data="mainTable.tableData"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getPreSalePlanTableRecord"
                    />
                </Col>
            </Row>
        </Card>
        <week-modal ref="weekModal" @close="onWeekModalClose" />

        <week-binding-modal
            ref="weekBindingModal"
            @close="onWeekBindingModalClose"
        />

        <Modal v-model="priceModal.show" title="选择价格">
            <RadioGroup v-model="priceModal.preSalePlanPriceIndex">
                <Radio :label="1">
                    <span>{{ "预售价1: ￥" + priceModal.price1 }}</span>
                </Radio>
                <Radio :label="2">
                    <span>{{ "预售价2: ￥" + priceModal.price2 }}</span>
                </Radio>
                <Radio :label="3">
                    <span>{{ "预售价3: ￥" + priceModal.price3 }}</span>
                </Radio>
                <Radio :label="4">
                    <span>{{ "预售价4: ￥" + priceModal.price4 }}</span>
                </Radio>
            </RadioGroup>
            <div slot="footer">
                <Button type="primary" @click="onUpdatePlanPrice">设置</Button>
            </div>
        </Modal>

        <Modal
            v-model="planImportModel.show"
            title="请选择要导入的文件"
            :mask-closable="false"
            @on-ok="onImportPlan"
            :loading="true"
            width="300"
        >
            <div style="display: flex; justify-content: space-between">
                <Upload
                    :show-upload-list="false"
                    :action="UPLOAD_FILE_API"
                    :format="['xlsx']"
                    :on-success="handleSuccess"
                    :on-format-error="handleFormatError"
                >
                    <Button icon="ios-cloud-upload-outline">选择文件</Button>
                </Upload>

                <Button
                    icon="ios-cloud-download-outline"
                    @click="downloadImportTemplate()"
                    >下载模板</Button
                >
            </div>
            <div>{{ planImportModel.fileName }}</div>
        </Modal>
        <Modal
            v-model="planExportByDateModel.show"
            title="请选择要导出的周期"
            :mask-closable="false"
            @on-ok="onImportPlan"
            :loading="true"
            footer-hide
            width="600"
        >
            <Form :label-width="80">
                <Row :gutter="16">
                    <Col span="10" offset="1">
                        <FormItem label="开始年份">
                            <Select v-model="planExportByDateModel.beginYear">
                                <Option
                                    v-for="item in planExportByDateBeginYearList"
                                    :value="item"
                                    :key="item"
                                    >{{ item }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="10">
                        <FormItem label="开始周数">
                            <Select v-model="planExportByDateModel.beginWeek">
                                <Option
                                    v-for="item in planExportByDateBeginWeekList"
                                    :value="item"
                                    :key="item"
                                    >{{ item }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="10" offset="1">
                        <FormItem label="结束年份">
                            <Select v-model="planExportByDateModel.endYear">
                                <Option
                                    v-for="item in planExportByDateEndYearList"
                                    :value="item"
                                    :key="item"
                                    >{{ item }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="10">
                        <FormItem label="结束周数">
                            <Select v-model="planExportByDateModel.endWeek">
                                <Option
                                    v-for="item in planExportByDateEndWeekList"
                                    :value="item"
                                    :key="item"
                                    >{{ item }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="4" offset="16">
                        <Button
                            type="info"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            @click="onExportByDateRange()"
                            >确认导出</Button
                        >
                    </Col>
                </Row>
            </Form>
        </Modal>
    </div>
</template>

<script>
import WeekModal from "./week-modal";
import WeekBindingModal from "./week-binding-modal";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import SearchCard from "@/components/searchCard/searchCard.vue";
import IntegerInput from "@/components/number-input/integer-input";
import { number2ThousandsFormat } from "@/components/number-input/display-format";
import { getWeek } from "@/libs/logic";
import { DOWNLOAD_SERVER, UPLOAD_FILE_API } from "@/api/modules/files";

import {
    getMyPreSalePlan,
    getMyPreSalePlanByDateRange,
    getPreSalePlanWeeks,
    getWeekConfig,
    getWeekConfigYears,
    importPreSalePlan,
    saveMyPreSalePlan
} from "@/api/modules/preSale-management/preSale-plan";
import { updateProductPrice } from "@/api/modules/product-management/productPrice-management";

import {
    getSeedFarmList,
    saveSeedFarmWeekBinding
} from "@/api/modules/system-management/seedFarm-management";
import CurrencyInput from "@/components/number-input/currency-input";
export default {
    name: "preSale-plan",
    components: {
        WeekModal,
        WeekBindingModal,
        StandPaginationTable,
        SearchCard,
        IntegerInput,
        CurrencyInput
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const tableSearch = search.getSearchParams();

        return {
            UPLOAD_FILE_API,
            year: 0,
            yearList: [],
            weekConfig: {},
            weekBinding: {},
            checkedWeeks: [],
            mainTable: {
                tableColumns: [],
                tableData: [],
                tableSearch: tableSearch,
                loading: false
            },
            setAmountModal: {
                show: false,
                productUuid: "",
                amount: 0
            },
            priceModal: {
                show: false,
                preSalePlanUuid: "",
                preSalePlanPriceIndex: 0,
                price1: 0,
                price2: 0,
                price3: 0,
                price4: 0,
                rowIndex: 0,
                planIndex: 0
            },
            keyWord: "",
            seedFarmList: "",
            selectedSeedFarmUuid: "",
            existsOnly: false,
            receivedOrder: false,
            planImportModel: {
                show: false,
                loading: false,
                fileWebName: "",
                fileName: ""
            },
            planExportByDateModel: {
                show: false,
                beginYear: "",
                beginWeek: "",
                endYear: "",
                endWeek: "",
                yearList: [],
                yearWeekList: []
            },
            subQuantity: {},
            productTotalSaleCount: {},
            isMainAccount: 0,
            priceChangeList: []
        };
    },
    computed: {
        planExportByDateBeginYearList() {
            if (!this.planExportByDateModel.endYear) {
                return this.planExportByDateModel.yearList;
            }
            else {
                return this.planExportByDateModel.yearList.filter(
                    (item) => item <= this.planExportByDateModel.endYear
                );
            }
        },
        planExportByDateBeginWeekList() {
            if (this.planExportByDateModel.yearWeekList.length < 1) {
                return [];
            }
            let weeks
                = this.planExportByDateModel.yearWeekList[
                    this.planExportByDateModel.beginYear.toString()
                ];
            if (
                this.planExportByDateModel.beginYear
                == this.planExportByDateModel.endYear
            ) {
                return weeks.filter(
                    (item) => item <= this.planExportByDateModel.endWeek
                );
            }
            else {
                return weeks;
            }
        },
        planExportByDateEndYearList() {
            if (!this.planExportByDateModel.beginYear) {
                return this.planExportByDateModel.yearList;
            }
            else {
                return this.planExportByDateModel.yearList.filter(
                    (item) => item >= this.planExportByDateModel.beginYear
                );
            }
        },
        planExportByDateEndWeekList() {
            if (this.planExportByDateModel.yearWeekList.length < 1) {
                return [];
            }
            let weeks
                = this.planExportByDateModel.yearWeekList[
                    this.planExportByDateModel.endYear.toString()
                ];
            if (
                this.planExportByDateModel.beginYear
                == this.planExportByDateModel.endYear
            ) {
                return weeks.filter(
                    (item) => item >= this.planExportByDateModel.beginWeek
                );
            }
            else {
                return weeks;
            }
        }
    },
    mounted() {
        const date = new Date();
        this.year = date.getFullYear();
        this.yearList = [
            this.year,
            this.year + 1,
            this.year + 2,
            this.year + 3
        ];
        this.planExportByDateModel.yearList = [
            this.year - 2,
            this.year - 1,
            this.year,
            this.year + 1,
            this.year + 2
        ];
        this.planExportByDateModel.beginYear = this.year;
        this.planExportByDateModel.endYear = this.year;
        this.getAllSeedFarm();
        if (!this.readOnly) {
            this.getPlanWeeks();
        }
        this.getWeekConfigYears();
    },
    methods: {
        handleSuccess(res, file) {
            this.planImportModel.fileWebName = res.data.fileList[0].fileUuid;
            this.planImportModel.fileName = res.data.fileList[0].fileName;
        },
        handleFormatError(file) {
            const str = this.format.join(", ");
            this.$Notice.warning({
                title: "文件格式错误",
                desc: "请选择 " + str + " 后缀的文件."
            });
        },
        onClickImport() {
            this.planImportModel.fileName = "";
            this.planImportModel.fileWebName = "";
            this.planImportModel.show = true;
        },
        onImportPlan() {
            importPreSalePlan({
                importFileName: this.planImportModel.fileWebName
            }).then((res) => {
                this.planImportModel.show = false;
                if (res.code === 0) {
                    this.getPlanWeeks();
                    this.$Modal.success({
                        title: "导入成功",
                        content: ""
                    });
                }
            });
        },
        downloadImportTemplate() {
            let url
                = DOWNLOAD_SERVER + "Import/template/plan_import_template.xlsx";
            this.$downLoadFile(url);
        },
        getPriceByIdx() {
            let idx = this.priceModal.preSalePlanPriceIndex;
            switch (idx) {
                case 1:
                    return this.priceModal.price1;
                case 2:
                    return this.priceModal.price2;
                case 3:
                    return this.priceModal.price3;
                case 4:
                    return this.priceModal.price4;
            }
        },
        onUpdatePlanPrice() {
            this.mainTable.tableData[this.priceModal.rowIndex].plans[
                this.priceModal.planIndex
            ].preSalePlanPriceIndex = this.priceModal.preSalePlanPriceIndex;
            this.mainTable.tableData[this.priceModal.rowIndex].plans[
                this.priceModal.planIndex
            ].preSalePlanPrice = this.getPriceByIdx();
            this.mainTable.tableData[this.priceModal.rowIndex].plans[
                this.priceModal.planIndex
            ].changed = true;
            this.priceModal.show = false;
        },
        onSeedFarmChange() {
            if (this.selectedSeedFarmUuid) {
                this.getPlanWeeks();
            }
        },
        getAllSeedFarm() {
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            getSeedFarmList(tempSearch).then((res) => {
                if (res.code === 0) {
                    this.mainTable.tableSearch.limit.conditions.pageLength = 20;
                    this.seedFarmList = res.data.records;
                }
            });
        },
        onSearch() {
            let field = "CONCAT(productName, productCode, subCategoryName)";
            search.globalRemoveFilterConditionKey(
                this.mainTable.tableSearch,
                field
            );
            if (this.keyWord) {
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: field,
                    type: "like",
                    value: this.keyWord
                });
            }
            search.globalResetSearch(this.mainTable.tableSearch);
            this.getPreSalePlanTableRecord();
        },
        onYearChange() {
            this.getPlanWeeks();
        },
        getPlanWeeks() {
            this.mainTable.loading = true;
            getPreSalePlanWeeks(this.year, this.selectedSeedFarmUuid).then(
                (res) => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        res.data.forEach((e) => {
                            this.weekBinding[e.weekSeq] = e.seedFarmWeekBindingName;
                        });

                        let weeks = res.data.map((w) => {
                            return w.weekSeq;
                        });

                        this.$refs.weekModal.setCheckedWeeks(weeks);
                        this.mainTable.loading = true;
                        getWeekConfig(this.year).then((res) => {
                            this.mainTable.loading = false;
                            if (res.code === 0) {
                                res.data.forEach((week) => {
                                    this.weekConfig[week.weekSeq] = week;
                                });

                                let allWeeks = res.data.map((w) => {
                                    return w.weekSeq;
                                });

                                this.$refs.weekModal.initWeeks(allWeeks);

                                this.onWeekModalClose(weeks);
                            }
                        });
                    }
                }
            );
        },
        getWeekConfigYears() {
            getWeekConfigYears(this.planExportByDateModel.yearList).then(
                (res) => {
                    if (res.code == 0) {
                        this.planExportByDateModel.yearWeekList
                            = res.data.weekData;
                        this.planExportByDateModel.beginWeek
                            = res.data.curretWeek;
                        let endweeks
                            = res.data.weekData[
                                this.planExportByDateModel.endYear.toString()
                            ];
                        this.planExportByDateModel.endWeek
                            = endweeks[endweeks.length - 1];
                    }
                }
            );
        },
        showModal() {
            this.$refs.weekModal.showModal(this.year);
        },
        showBindindModal() {
            this.$refs.weekBindingModal.showModal(this.year);
        },
        onWeekBindingModalClose(weeks, bindingName) {
            let weekUuids = Object.values(this.weekConfig)
                .filter((w) => {
                    return weeks.includes(w.weekSeq);
                })
                .map((k) => {
                    return k.weekUuid;
                });

            let data = {
                weekUuids: weekUuids,
                bindingName: bindingName
            };

            this.$Spin.show();
            saveSeedFarmWeekBinding(data).then((res) => {
                this.$Spin.hide();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: "设置成功",
                        onOk: () => {
                            window.location.reload();
                        }
                    });
                }
            });
        },
        updateProductPrice(productRow) {
            const data = {
                productUuid: productRow.productUuid,
                productTag: `${productRow.productName}（${productRow.productCode}）`,
                productCurSalePriceStatus: productRow.productCurSalePriceStatus,
                productCurSalePrice: productRow.productCurSalePrice,
                productPreSalePriceStatus: productRow.productPreSalePriceStatus,
                productPreSalePrice: productRow.productPreSalePrice,
                productPreSalePrice2: productRow.productPreSalePrice2,
                productPreSalePrice3: productRow.productPreSalePrice3,
                productPreSalePrice4: productRow.productPreSalePrice4
            };

            const submitData = {
                productPrices: [data]
            };
            this.$Spin.show();
            updateProductPrice(submitData)
                .then((res) => {
                    this.$Spin.hide();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "更新成功",
                            content: "",
                            onOk: () => {}
                        });
                    }
                })
                .catch(() => {
                    this.$Spin.hide();
                });
        },
        onWeekModalClose(weeks) {
            this.checkedWeeks = weeks;
            this.getColumns();
            // 查询数据
            this.getPreSalePlanTableRecord();
        },

        getColumns() {
            // 重置表格列
            let defaultColumns = [
                {
                    title: "行号",
                    type: "index",
                    width: 60,
                    align: "center",
                    fixed: "left"
                },
                {
                    title: "产品编码",
                    key: "productCode",
                    align: "center",
                    width: 60,
                    fixed: "left"
                },
                {
                    title: "产品名称",
                    key: "productName",
                    align: "center",
                    width: 80,
                    fixed: "left"
                },
                {
                    title: "预售价",
                    key: "productPreSalePrice",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice = value;
                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice = value;
                                    }
                                }
                            }
                        });
                    }
                },
                {
                    title: "预售价2",
                    key: "productPreSalePrice2",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice2,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice2 = value;
                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice2 = value;
                                    }
                                }
                            }
                        });
                    }
                },
                {
                    title: "预售价3",
                    key: "productPreSalePrice3",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice3,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice3 = value;
                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice3 = value;
                                    }
                                }
                            }
                        });
                    }
                },
                {
                    title: "预售价4",
                    key: "productPreSalePrice4",
                    align: "center",
                    width: 70,
                    fixed: "left",
                    render: (h, params) => {
                        return h(CurrencyInput, {
                            props: {
                                value: params.row.productPreSalePrice4,
                                precision: 4
                            },
                            style: {
                                visibility: !this.mainTable.tableData[
                                    params.index
                                ].isTotal
                                    ? "visible"
                                    : "hidden",
                                textAlign: "center",
                                width: "68px"
                            },
                            on: {
                                change: (value) => {
                                    this.mainTable.tableData[
                                        params.index
                                    ].productPreSalePrice4 = value;
                                    const productUuid = params.row.productUuid;
                                    const query = this.priceChangeList.find(
                                        (p) => p.productUuid === productUuid
                                    );
                                    if (query) {
                                        query.newProductPreSalePrice4 = value;
                                    }
                                }
                            }
                        });
                    }
                }/* ,
                {
                    title: "更新预售价",
                    key: "action",
                    align: "center",
                    width: 80,
                    fixed: "left",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "text",
                                        size: "small",
                                        shape: "circle",
                                    },
                                    style: {
                                        visibility:
                                            this.$checkAccessArray([
                                                "B",
                                                "C",
                                            ]) &&
                                            !this.mainTable.tableData[
                                                params.index
                                            ].isTotal
                                                ? "visible"
                                                : "hidden",
                                    },
                                    on: {
                                        click: () => {
                                            this.updateProductPrice(params.row);
                                        },
                                    },
                                },
                                "更新"
                            ),
                        ]);
                    },
                }, */
            ];

            const weekSort = this.checkedWeeks.sort((a, b) => {
                return a - b;
            });

            weekSort.forEach((w) => {
                const week = this.weekConfig[w];
                const bindingName = this.weekBinding[w]
                    ? " - " + this.weekBinding[w]
                    : "";
                const weekBeginEnd
                    = week.weekBeginDate.substr(5)
                    + " ~ "
                    + week.weekEndDate.substr(5);

                const weekColumn = {
                    title: `第${w}周${bindingName}` + weekBeginEnd,
                    align: "center",
                    renderHeader: (h, { column, index }) => {
                        return h(
                            "div",
                            {
                                style: {
                                    color: "red"
                                }
                            },
                            `第${w}周${bindingName}` + weekBeginEnd
                        );
                    },
                    children: [
                        {
                            title: "已接单量",
                            align: "center",
                            width: 80,
                            className: "week-column",
                            render: (h, params) => {
                                const weekElement = h(
                                    "span",
                                    {
                                        style: {
                                            display: "none"
                                        }
                                    },
                                    params.row.plans[w].totalRemark
                                );
                                const weekSaleCountElement = h(
                                    "div",
                                    {
                                        style: {
                                            float: "center"
                                        }
                                    },
                                    params.row.plans[w].productTotalSaleCount
                                        ? params.row.plans[w].productTotalSaleCount
                                        : 0
                                );

                                return h(
                                    "div",
                                    {
                                        style: {
                                            textAlign: "center"
                                        }
                                    },
                                    [weekElement, weekSaleCountElement]
                                );
                            }
                        },
                        {
                            title: "可供货量",
                            align: "center",
                            width: 100,
                            className: "week-column",
                            render: (h, params) => {
                                if (!params.row.plans[w]) {
                                    let zeroItem = {
                                        productUuid:
                                            this.mainTable.tableData[
                                                params.index
                                            ].productUuid,
                                        week: w,
                                        weekSeq: w,
                                        preSalePlanOfferAmount: 0,
                                        preSalePlanPrice: 0,
                                        preSalePlanPublic: 1,
                                        preSalePlanPriceIndex: 1,
                                        changed: true
                                    };
                                    params.row.plans[w] = zeroItem;
                                    this.mainTable.tableData[
                                        params.index
                                    ].plans[w] = zeroItem;
                                }
                                if (
                                    params.row.plans[w]
                                        .preSalePlanPriceIndex === 0
                                ) {
                                    params.row.plans[
                                        w
                                    ].preSalePlanPriceIndex = 1;
                                    this.mainTable.tableData[
                                        params.index
                                    ].plans[w].preSalePlanPriceIndex = 1;
                                }
                                const weekElement = h(
                                    "span",
                                    {
                                        style: {
                                            display: "none"
                                        }
                                    },
                                    params.row.plans[w].totalRemark
                                );
                                const priceElement = h(
                                    "a",
                                    {
                                        on: {
                                            click: () => {
                                                this.priceModal.price1 = params.row.productPreSalePrice;
                                                this.priceModal.price2 = params.row.productPreSalePrice2;
                                                this.priceModal.price3 = arams.row.productPreSalePrice3;
                                                this.priceModal.price4 = params.row.productPreSalePrice4;
                                                this.priceModal.preSalePlanUuid = params.row.plans[w].preSalePlanUuid;
                                                this.priceModal.preSalePlanPriceIndex = params.row.plans[w].preSalePlanPriceIndex;
                                                this.priceModal.rowIndex = params.index;
                                                this.priceModal.planIndex = w;
                                                this.priceModal.show = true;
                                            }
                                        }
                                    },
                                    !params.row.plans[w].total
                                        ? "P" + params.row.plans[w].preSalePlanPriceIndex
                                        : ""
                                );

                                const offerAmountElement = h(IntegerInput, {
                                    props: {
                                        value: params.row.plans[w]
                                            .preSalePlanOfferAmount,
                                        max: 99999999,
                                        size: "small"
                                    },
                                    style: {
                                        display: params.row.plans[w]
                                            .totalPreSalePlanOfferAmount
                                            ? "none"
                                            : "inline",
                                        width: "60px",
                                        float: "right"
                                    },
                                    on: {
                                        change: (val) => {
                                            let changedProduct
                                                = this.mainTable.tableData[
                                                    params.index
                                                ];
                                            let changedPlan
                                                = changedProduct.plans[w];
                                            changedPlan.preSalePlanOfferAmount
                                                = val;
                                            changedPlan.changed = true;
                                            changedPlan.isChangedQuantity = true;
                                        }
                                    },
                                    nativeOn: {
                                        keyup: (e) => {
                                            //按回车，直接跳转到下一输入框
                                            if (e.keyCode === 13) {
                                                this.getNextFocus(e);
                                            }
                                        }
                                    }
                                });
                                const totalAmountElement = h(
                                    "span",
                                    {
                                        style: {
                                            display: !params.row.plans[w]
                                                .totalPreSalePlanOfferAmount
                                                ? "none"
                                                : "inline"
                                        }
                                    },
                                    params.row.plans[w]
                                        .totalPreSalePlanOfferAmount
                                );
                                return h(
                                    "div",
                                    {
                                        style: {
                                            textAlign: "center"
                                        }
                                    },
                                    [
                                        //	weekElement,
                                        priceElement,
                                        offerAmountElement,
                                        totalAmountElement
                                    ]
                                );
                            }
                        }
                    ]
                };
                if (!this.receivedOrder) {
                    weekColumn.children = weekColumn.children.filter(
                        (x) => x.title != "已接单量"
                    );
                }
                defaultColumns.push(weekColumn);
            });
            this.mainTable.tableColumns = defaultColumns;
        },
        getNextFocus(e) {
            let parentTdNode = e.target.parentNode.parentNode.parentNode.parentNode.parentNode;
            let nextTd = parentTdNode.nextSibling;
            if (nextTd) {
                let cell = nextTd.querySelector(".ivu-input-number-input");
                if (cell) {
                    cell.focus();
                }
            }
            else {
                //换行
                let nextRow = parentTdNode.parentNode.nextElementSibling;
                if (nextRow) {
                    let cell = nextRow.querySelector(".ivu-input-number-input");
                    if (cell) {
                        cell.focus();
                    }
                }
            }
        },
        onShowExistsOnly() {
            this.getPreSalePlanTableRecord(true);
        },
        onShowReceivedOrder() {
            this.getColumns();
        },
        onExport() {
            const queryData = Object.assign(this.mainTable.tableSearch, {
                year: this.year,
                weeks: this.checkedWeeks,
                seedFarmUuid: this.selectedSeedFarmUuid,
                existsOnly: this.existsOnly,
                needExport: true
            });
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.loading = true;
            getMyPreSalePlan(queryData)
                .then((res) => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        window.open(
                            DOWNLOAD_SERVER + res.data.exportFileName,
                            "_blank"
                        );
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        onExportByDateRange() {
            let beginYear = this.planExportByDateModel.beginYear;
            let beginWeek = this.planExportByDateModel.beginWeek;
            let endYear = this.planExportByDateModel.endYear;
            let endWeek = this.planExportByDateModel.endWeek;
            if (beginYear * 100 + beginWeek > endYear * 100 + endWeek) {
                this.$Message.error("开始周期不能大于结束周期");
                return;
            }
            const queryData = Object.assign(this.mainTable.tableSearch, {
                beginYear,
                beginWeek,
                endYear,
                endWeek,
                seedFarmUuid: this.selectedSeedFarmUuid,
                needExport: true
            });
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.loading = true;
            getMyPreSalePlanByDateRange(queryData)
                .then((res) => {
                    this.mainTable.loading = false;
                    this.planExportByDateModel.show = false;
                    if (res.code === 0) {
                        window.open(
                            DOWNLOAD_SERVER + res.data.exportFileName,
                            "_blank"
                        );
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                    this.planExportByDateModel.show = false;
                });
        },
        onExportByDateRangeShow() {
            this.planExportByDateModel.show = true;
        },
        fakeSumRowDisplay(subQuantityData) {
            let fakeSumRowId = `mainTable-fake-sum-row`;
            let fakeSumRowExtendId = `mainTable-fake-sum-row-extend`;
            let findFakeSumRow = document.getElementById(fakeSumRowId);
            let findFakeSumRowExtend
                = document.getElementById(fakeSumRowExtendId);
            if (findFakeSumRow !== null) {
                findFakeSumRow.parentNode.removeChild(findFakeSumRow);
            }
            if (findFakeSumRowExtend !== null) {
                findFakeSumRowExtend.parentNode.removeChild(
                    findFakeSumRowExtend
                );
            }

            let tableDiv = this.$refs.mainTable.$refs.standPaginationTable.$el;
            let ivuTableDiv = tableDiv.querySelector(".ivu-table");
            let ivuTableTBody = ivuTableDiv
                .querySelector(".ivu-table-body")
                .querySelector(".ivu-table-tbody");
            let ivuTableFixBody = ivuTableDiv
                .querySelector(".ivu-table-fixed-body")
                .querySelector(".ivu-table-tbody");
            if (ivuTableTBody.children.length > 0) {
                let lastTr = ivuTableTBody.lastElementChild;
                let copyTr = lastTr.cloneNode(true);

                let lastFixTr = ivuTableFixBody.lastElementChild;
                let copyFixTr = lastFixTr.cloneNode(true);

                copyTr.id = fakeSumRowId;
                copyFixTr.id = fakeSumRowExtendId;
                for (let colIndex = 0; colIndex < 6; colIndex++) {
                    let targetTd = copyFixTr.children[colIndex];
                    let cell = targetTd.querySelector(".ivu-table-cell");
                    cell.innerHTML = " ";
                }
                for (
                    let colIndex = 6;
                    colIndex < copyTr.children.length;
                    colIndex++
                ) {
                    let targetTd = copyTr.children[colIndex];
                    let cell = targetTd.querySelector(".ivu-table-cell");
                    let w = cell.querySelector("span").innerHTML;
                    if (colIndex % 2 === 0) {
                        cell.innerHTML
                            = "合计: "
                            + (this.subQuantity[w] ? this.subQuantity[w] : "0");
                    }
                    else {
                        cell.innerHTML
                            = "合计: "
                            + (this.productTotalSaleCount[w]
                                ? this.productTotalSaleCount[w]
                                : "0");
                    }
                }

                ivuTableFixBody.append(copyFixTr);
                ivuTableTBody.append(copyTr);
            }
        },
        getPreSalePlanTableRecord(reset = false) {
            const queryData = Object.assign(this.mainTable.tableSearch, {
                year: this.year,
                weeks: this.checkedWeeks,
                seedFarmUuid: this.selectedSeedFarmUuid,
                existsOnly: this.existsOnly,
                needExport: false
            });

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            //	this.mainTable.tableSearch.limit.enable = true;
            this.mainTable.loading = true;
            getMyPreSalePlan(queryData)
                .then((res) => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        this.mainTable.tableData = res.data.records;
                        // 记录当页的商品价格原始信息
                        this.priceChangeList = this.mainTable.tableData.map(
                            (row) => {
                                return {
                                    productUuid: row.productUuid,
                                    productTag: `${row.productName}（${row.productCode}）`,
                                    oldProductPreSalePriceStatus:
                                        row.productPreSalePriceStatus,
                                    newProductPreSalePriceStatus:
                                        row.productPreSalePriceStatus,
                                    oldProductPreSalePrice:
                                        row.productPreSalePrice,
                                    newProductPreSalePrice:
                                        row.productPreSalePrice,
                                    oldProductPreSalePrice2:
                                        row.productPreSalePrice2,
                                    newProductPreSalePrice2:
                                        row.productPreSalePrice2,
                                    oldProductPreSalePrice3:
                                        row.productPreSalePrice3,
                                    newProductPreSalePrice3:
                                        row.productPreSalePrice3,
                                    oldProductPreSalePrice4:
                                        row.productPreSalePrice4,
                                    newProductPreSalePrice4:
                                        row.productPreSalePrice4
                                };
                            }
                        );
                        this.subQuantity = res.data.subQuantity;
                        this.productTotalSaleCount = res.data.productTotalSaleCount;
                        this.isMainAccount = res.data.isMainAccount;
                        let totalDate = {};
                        totalDate.isTotal = true;
                        totalDate.plans = {};

                        this.checkedWeeks.forEach((x) => {
                            let plan = {};
                            plan["total"] = true;
                            let productTotalSaleCount = res.data.productTotalSaleCount && res.data.productTotalSaleCount[x] ? res.data.productTotalSaleCount[x] : 0;
                            plan["productTotalSaleCount"] = "合计:" + productTotalSaleCount;
                            let totalPreSalePlanOfferAmount = res.data.subQuantity && res.data.subQuantity[x] ? res.data.subQuantity[x] : 0;
                            plan["totalPreSalePlanOfferAmount"] = "合计:" + totalPreSalePlanOfferAmount;
                            totalDate.plans[x] = plan;
                        });

                        this.mainTable.tableData.push(totalDate);
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                        // this.$nextTick(() => {
                        // 	this.fakeSumRowDisplay();
                        // });
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        onSave() {
            const products = [];
            this.mainTable.tableData.forEach((product) => {
                Object.keys(product.plans).forEach((weekKey) => {
                    const week = product.plans[weekKey];
                    if (week.changed) {
                        products.push({
                            productUuid: product.productUuid,
                            week: week.weekSeq,
                            preSalePlanOfferAmount: week.preSalePlanOfferAmount,
                            preSalePlanPrice: week.preSalePlanPrice,
                            preSalePlanPublic: week.preSalePlanPublic,
                            preSalePlanPriceIndex: week.preSalePlanPriceIndex,
                            isChangedQuantity: week.isChangedQuantity
                                ? true
                                : false
                        });
                    }
                });
            });

            if (products.length === 0) {
                this.$Modal.warning({
                    title: "暂无修改内容",
                    content: ""
                });
                return;
            }

            const data = {
                year: this.year,
                products: products
            };
            this.$Spin.show();
            saveMyPreSalePlan(data)
                .then((res) => {
                    this.$Spin.hide();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            content: ""
                        });
                        this.getPreSalePlanTableRecord();
                    }
                    else {
                        this.getPreSalePlanTableRecord();
                    }
                })
                .catch(() => {
                    this.$Spin.hide();
                });
        },
        updateRow(row) {
            this.params.row.forEach((item) => {
                productPreSalePrice = row.productPreSalePrice;
                productPreSalePrice2 = row.productPreSalePrice;
                productPreSalePrice3 = row.productPreSalePrice;
                productPreSalePrice4 = row.productPreSalePrice;
            });
        }
    }
};
</script>

<style lang="less">
.week-column /deep/ .ivu-table-cell {
    padding-left: 2px;
    padding-right: 2px;
}

.ivu-table-fixed {
    margin-bottom: 10px !important;
    height: auto !important;
}
</style>
